/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'html': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(6 8)" _stroke="#00272E"><rect pid="0" x=".417" y=".4" width="19.167" height="15.2" rx="1.62"/><path pid="1" d="M.417 4.4h19.166"/><path pid="2" d="M3.333 2.2c.115 0 .209.09.209.2 0 .11-.094.2-.209.2a.204.204 0 01-.208-.2c0-.11.093-.2.208-.2"/><path pid="3" d="M5.833 2.2c.115 0 .209.09.209.2 0 .11-.094.2-.209.2a.204.204 0 01-.208-.2c0-.11.093-.2.208-.2"/><path pid="4" d="M8.333 2.2c.115 0 .209.09.209.2 0 .11-.094.2-.209.2a.204.204 0 01-.208-.2c0-.11.093-.2.208-.2"/><path pid="5" d="M7.917 11.6v-4"/><path pid="6" d="M7.083 7.6H8.75"/><path pid="7" d="M3.75 11.6v-4"/><path pid="8" d="M5.417 11.6v-4"/><path pid="9" d="M3.75 10h1.667"/><path pid="10" d="M14.583 7.6v3.2c0 .442.373.8.834.8h.833"/><polyline pid="11" points="12.9166667 11.6 12.9166667 7.6 11.6666667 9.6 10.4166667 7.6 10.4166667 11.6"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/html.js